export default remote => ({
    create: (params) => remote.put(`partner/troubleflight`, params)
});
